export default __webpack_public_path__ + "02b05e28ee827fa3fb408003b170f3d6.png";